export const BASE = {
  API: 'https://api.adotapetce.com.br',
};

// https://api.adotapet.com.br
// https://apidev.adotapet.com.br
